import { RootState } from "../../../../../redux/store";

export const isItemsLoading = (state:RootState) => state.cities.itemsLoading;
export const isItemActionLoading = (state:RootState) => state.cities.actionsLoading;
export const getItems = (state:RootState) => state.cities.items;
export const getItemsSelect = (state:RootState) => state.cities.dropDownItems;
export const getItemsForBillingSelect = (state:RootState) => state.cities.entitiesForBillingSelect;

export const getItemsSelectLoading = (state:RootState) => state.cities.dropDownLoading;
export const getItemsCount = (state:RootState) => state.cities.itemsCount;
export const getItemForEdit = (state:RootState) => state.cities.itemForEdit;
export const getError = (state:RootState) => state.cities.error;
export const getErrorAction = (state:RootState) => state.cities.errorAction
export const validationErrors = (state: RootState) => state.cities.validationErrors;
